<template>
    <Breadcrumbs main="Bonus Ui" title="Animated Modal" />
    <div class="container-fluid">
        <div class="row">

            <animationBox />

        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const animationBox = defineAsyncComponent(() => import("@/components/theme/advance/animation/animationBox.vue"))

</script>